module.exports = __webpack_public_path__ + "fonts/BrandonText-Medium.d5e252ed.otf";